import { IsDefined, IsString, Length } from 'class-validator';

export class BillingChannelTypeCreateDto{
  @IsDefined()
  @IsString()
  @Length(0, 150)
  name: string;
}